const LB_PER_KG = 2.204_622_6218;
const CM_PER_IN = 2.54;

export function kgToLbs(kg: number): number {
  return kg * LB_PER_KG;
}

export function lbsToKg(lbs: number): number {
  return lbs / LB_PER_KG;
}

export function cmToFtIn(cm: number): { feet: number; inches: number } {
  const totalIn = cm / CM_PER_IN;
  const feet = Math.floor(totalIn / 12);
  const inches = totalIn - feet * 12;
  return { feet, inches: Math.round(inches * 100) / 100 };
}

export function ftInToCm(ft: number, inch: number): number {
  return (ft * 12 + inch) * CM_PER_IN;
}
